import React from "react";
import "./Copyright.css";

function Copyright() {
  return (
    <div className="copyright">
      <p className="copyright-text">Created by Shihab Ahmed. © 2024</p>
    </div>
  );
}

export default Copyright;
